module.exports = __webpack_public_path__ + "static/media/logo-onoake-white.f527196f.png";